import { render, staticRenderFns } from "./my-home.vue?vue&type=template&id=746b5500&scoped=true&"
import script from "./my-home.vue?vue&type=script&lang=js&"
export * from "./my-home.vue?vue&type=script&lang=js&"
import style0 from "./my-home.vue?vue&type=style&index=0&id=746b5500&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746b5500",
  null
  
)

export default component.exports